//React
import { FunctionComponent } from "react";

//Selectors
import { useAppSelector } from "../../system/redux/hooks/redux-store-hooks";
import { selectSelectedFacetCount } from "../redux/selectors/select-selected-facet-count";

//The link to the facet modal above the result list, this also shows the count of selected facets.
const FacetLink: FunctionComponent = (props) => {
	const facetCount = useAppSelector(selectSelectedFacetCount);

	if (facetCount > 0) {
		return (
			<span>
				<span className="badge">{facetCount > 0 && facetCount}</span>
			</span>
		);
	} else {
		return (
			<span>
				<span></span>
			</span>
		);
	}
};
export default FacetLink;
